export interface EndpointConfig {
  baseUrl: string;
}

export interface StorageConfig extends EndpointConfig {}

export interface AppConfig {
  api: EndpointConfig;
  environment: string;
  aiEvalTabEnabled: string;
  azureStorage: StorageConfig;
}

export const appConfig: AppConfig = {
  api: {
    baseUrl: window.location.origin,
  },
  environment: import.meta.env.VITE_ENV,
  aiEvalTabEnabled: import.meta.env.VITE_SHOW_AI_EVAL_TAB,
  azureStorage: {
    baseUrl: import.meta.env.VITE_AZURE_STORAGE_BASE_URL,
  },
};

export const isTestEnvironment = appConfig.environment === 'test';
export const isPpeEnvironment = appConfig.environment === 'ppe';
export const isAiEvalTabEnabled = appConfig.aiEvalTabEnabled === 'true';

export const storageBaseUrl = appConfig.azureStorage.baseUrl;
